module.exports = __webpack_public_path__ + "img/07-atelier-conversation.16b217b7.jpg";